module.exports = __webpack_public_path__ + "img/pending.40319d7d.svg";